/* import __COLOCATED_TEMPLATE__ from './upsell.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { select } from '@banking/ui/services/investments-workflow';
import { isInvestmentAccountPendingWithholding, toggleModalOpenAction, setOnboardingScreenAction, isRiskIneligibleForInvestment, addToRiskWaitlistAction } from '@banking/ui/workflows/investments';
import { INVEST_VIEW_BTC_UPSELL } from '@banking/ui/utils/invest-cdp-events';
let InvestmentsUpsell = (_dec = select(isInvestmentAccountPendingWithholding), _dec2 = select(state => state.isModalOpen), _dec3 = select(isRiskIneligibleForInvestment), _class = class InvestmentsUpsell extends Component {
  constructor(owner, args) {
    super(owner, args);

    // Skip linking flow because linking was completed via CashApp
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "cashAppPayKitSdk", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor4, this);
    _initializerDefineProperty(this, "startingStep", _descriptor5, this);
    _initializerDefineProperty(this, "isInvestmentAccountPendingWithholding", _descriptor6, this);
    _initializerDefineProperty(this, "isAutomationFlowOpen", _descriptor7, this);
    _initializerDefineProperty(this, "isRiskIneligibleForInvestment", _descriptor8, this);
    _defineProperty(this, "openFlowCallback", () => Promise.resolve());
    _defineProperty(this, "goToInvestments", () => null);
    if (args.shouldSkipLinking) {
      this.openAutomationFlow('accountRelationship');
    }
    this.goToInvestments = args.goToInvestments;
    this.dataApi.track(INVEST_VIEW_BTC_UPSELL, {
      token: this.capitalEngineContext.sessionContext.merchantToken
    });
  }
  async openAutomationFlow(startingStep) {
    if (startingStep) {
      this.startingStep = startingStep;
    }
    if (this.cashAppPayKitSdk?.restart) {
      await this.cashAppPayKitSdk.restart();
    }
    if (this.isInvestmentAccountPendingWithholding) {
      // For customers w/ an invest account but w/o withholding config, fast-forward them to the withholding config step
      this.startingStep = 'withholding';
    }
    if (this.isRiskIneligibleForInvestment) {
      this.startingStep = 'riskWaitlist';
      this.investmentsWorkflow.emit(addToRiskWaitlistAction());
    }
    this.investmentsWorkflow.emit(setOnboardingScreenAction(this.startingStep, true));
  }
  closeAutomationFlow() {
    this.investmentsWorkflow.emit(toggleModalOpenAction(false));
  }
  completeFlow() {
    this.investmentsWorkflow.emit(toggleModalOpenAction(false));
    this.goToInvestments();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cashAppPayKitSdk", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "startingStep", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'splash';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isInvestmentAccountPendingWithholding", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isAutomationFlowOpen", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isRiskIneligibleForInvestment", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openAutomationFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openAutomationFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeAutomationFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAutomationFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completeFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "completeFlow"), _class.prototype), _class);
export { InvestmentsUpsell as default };